var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoliciesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 41.205,
    height: 41.204,
    viewBox: "0 0 41.205 41.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.349 2.974H28.24a2.9 2.9 0 0 0-2.296-1.218A2.74 2.74 0 0 0 23.385 0h-5.568c-1.167 0-2.16.729-2.559 1.756a2.89 2.89 0 0 0-2.292 1.218H7.853a1.68 1.68 0 0 0-1.678 1.678v34.874a1.68 1.68 0 0 0 1.678 1.679h25.496a1.68 1.68 0 0 0 1.68-1.679V4.652a1.68 1.68 0 0 0-1.68-1.678m-1.68 34.872H9.534V6.331h3.434a2.89 2.89 0 0 0 2.361 1.222h10.547c.977 0 1.838-.482 2.361-1.222h3.436v31.517h-.004zm-3.554-21.771a1.68 1.68 0 0 1 1.641.422 1.68 1.68 0 0 1 0 2.373l-7 6.998a1.683 1.683 0 0 1-2.376 0l-4.312-4.312a1.68 1.68 0 0 1 2.374-2.375l3.124 3.125 4.716-4.713v-.88H14.79v10.828h11.493v-3.98l1.832-1.832v6.729c0 .504-.41.914-.916.914H13.873a.914.914 0 0 1-.914-.914v-12.66c0-.504.408-.913.914-.913h13.324c.506 0 .916.409.916.913v.277z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliciesIcon);
export default __webpack_public_path__ + "static/media/policies-icon.cdedb0b9232dec5afe2e7d7ed1c11382.svg";
export { ForwardRef as ReactComponent };